export default {
  categories: [],
  subcategories: [],
};
